// @flow
import React from 'react';
import '../../../static/scss/components/ui/textarea.scss';

type Props = {
  onChange: string => void,
  className?: string,
  onFocus?: () => void,
  placeholder?: string,
  id?: String,
  children: any,
  cypress?: string
};

const TextArea = ({
  onChange,
  children,
  placeholder = '',
  className = '',
  onFocus = () => {},
  id = '',
  cypress = null
}: Props) => (
  <textarea
    onFocus={onFocus}
    onChange={e => onChange(e.target.value)}
    placeholder={placeholder}
    className={`c-textarea ${className}`}
    value={children}
    id={id}
    data-cy={cypress}
  />
);

export default TextArea;
